import React, { useState, useRef, useEffect } from 'react';
import { useSocket } from '../context/SocketContext';
import { useSelector } from 'react-redux';
import { authApi } from '../api/api';
import { File } from 'react-feather';
const ChatApp = () => {
  const [newMessage, setNewMessage] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [selectedChat, setSelectedChat] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [isMobile, setIsMobile] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const messagesEndRef = useRef(null);
  const socket = useSocket();
  const [messages, setMessages] = useState([
    {
      id: 1,
      text: "Hello, how are you?",
      isMe: false,
      avatar: "KS",
      color: "#1976d2",
      timestamp: new Date(Date.now() - 60000),
      type: "text"
    },
    {
      id: 2,
      text: "I'm fine, thanks!",
      isMe: true,
      avatar: "ME",
      color: "#dc004e",
      timestamp: new Date(Date.now() - 30000),
      type: "text",
      replyTo: {
        id: 1,
        text: "Hello, how are you?",
        avatar: "KS",
        color: "#1976d2"
      }
    }
  ]);
  const token = useSelector((state_id) => state_id.auth.token);
  const userID = useSelector((state_id) => state_id.auth.id);
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [selectedTemplateMessage, setSelectedTemplateMessage] = useState(null);
  const [selectedDates, setSelectedDates] = useState({});
  const [replyTo, setReplyTo] = useState(null);

  const templates = [
    {
      id: 1,
      name: "Template 1",
      messages: [
        { id: 1, label: "Client datails Form", icon: "🗒️" },
      ]
    },
    {
      id: 2,
      name: "Template 2",
      messages: [
        { id: 3, label: "Feedback Request", icon: "🗒️" },
      ]
    }
  ];
  const contacts = [
    {
      id: 0,
      name: 'Kelvin Smith',
      avatar: 'KS',
      lastMessage: "I'm doing well! Just working on some React projects...",
      timestamp: new Date(Date.now() - 120000),
      unreadCount: 0,
      isOnline: true,
      color: '#1976d2'
    },
  ];
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setShowSidebar(false);
      }
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };
  useEffect(() => {
    if (userID) {
      socket.emit("join", userID);
    }
  }, [userID]);
  useEffect(() => {
    socket.on("newMessage", (message) => {
      // Ensure received messages are positioned on the left
      const formattedMessage = {
        ...message,
        isMe: false, // Received messages go on the left
        timestamp: message.timestamp || new Date(),
        avatar: message.avatar || 'U',
        color: message.color || '#666'
      };
      setMessages(prev => [...prev, formattedMessage]);
    });
    return () => socket.off("newMessage");
  }, []);
  const handleSendMessage = async () => {
    if (!newMessage.trim()) return;
    // Create the message object with proper structure for sent messages
    const message = {
      id: Date.now(), // Simple ID generation
      text: newMessage,
      sender: 'Me',
      timestamp: new Date(),
      isMe: true, // Sent messages go on the right
      avatar: 'ME',
      color: '#dc004e',
      replyTo: replyTo ? {
        id: replyTo.id,
        text: replyTo.text || replyTo.label || replyTo.fileName,
        type: replyTo.type,
        avatar: replyTo.avatar,
        color: replyTo.color
      } : null
    };
    const input_token = userID + 'SEND_MESSAGE';
    const apiUrl = 'sendMessage';
    const dataInput = {
      login_user_id: userID,
      receiver_id: 55, // Replace with dynamic user if needed
      message: newMessage,
    };
    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);
      if (data && data.success) {
        // Optional: do something on API success
        console.log('Message sent successfully');
      }
      // Emit to socket with proper message structure
      socket.emit("sendMessage", {
        ...message,
        sender_id: userID,
        receiver_id: 55,
        message: newMessage
      });
      // Add to local messages immediately for better UX
      setMessages(prev => [...prev, message]);
      setNewMessage('');
      setReplyTo(null); // Clear reply after sending
      // Scroll to bottom after sending
      setTimeout(scrollToBottom, 100);
    } catch (error) {
      console.error('Failed to send message or fetch API:', error);
    }
  };
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };
  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diff = now - date;
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    if (days === 0) {
      return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    } else if (days === 1) {
      return 'Yesterday';
    } else if (days < 7) {
      return date.toLocaleDateString([], { weekday: 'short' });
    } else {
      return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
    }
  };
  const filteredContacts = contacts.filter(contact =>
    contact.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const handleContactSelect = (contactId) => {
    setSelectedChat(contactId);
    if (isMobile) {
      setShowSidebar(false);
    }
  };
  // file uploading 
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const iconMap = {
      pdf: '📄',
      doc: '📃',
      docx: '📃',
      xls: '📊',
      xlsx: '📊',
      csv: '📊',
      txt: '📑',
      ppt: '📽️',
      pptx: '📽️',
      jpg: '🖼️',
      jpeg: '🖼️',
      png: '🖼️',
    };
    const extension = file.name.split('.').pop().toLowerCase();
    const icon = iconMap[extension] || '📁';
    const newMessage = {
      id: Date.now(),
      type: 'file',
      fileName: file.name,
      fileType: file.type,
      fileObject: file,
      icon,
      isMe: true,
      avatar: 'ME',
      color: '#dc004e',
      timestamp: new Date()
    };
    setMessages((prev) => [...prev, newMessage]);
    scrollToBottom();
  };
  return (
    <>
      <div style={{
        height: '100vh',
        display: 'flex',
        fontFamily: 'Roboto, Arial, sans-serif',
        backgroundColor: '#f5f5f5',
        position: 'relative'
      }}>
        {/* Mobile Overlay */}
        {isMobile && showSidebar && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.5)',
              zIndex: 998,
              animation: 'fadeIn 0.3s ease-in-out'
            }}
            onClick={() => setShowSidebar(false)}
          />
        )}
        {/* Left Sidebar */}
        <div style={{
          width: isMobile ? '85%' : '360px',
          maxWidth: isMobile ? '320px' : '360px',
          backgroundColor: 'white',
          borderRight: '1px solid #e0e0e0',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '2px 0 8px rgba(0,0,0,0.1)',
          position: isMobile ? 'fixed' : 'relative',
          left: isMobile ? (showSidebar ? '0' : '-100%') : '0',
          top: 0,
          height: '100vh',
          zIndex: 999,
          transition: 'left 0.3s ease-in-out'
        }}>
          {/* Sidebar Header */}
          <div style={{
            padding: isMobile ? '16px' : '20px',
            backgroundColor: '#1976d2',
            color: 'white'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '16px'
            }}>
              {isMobile && (
                <button
                  onClick={() => setShowSidebar(false)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: 'white',
                    fontSize: '20px',
                    cursor: 'pointer',
                    padding: '4px'
                  }}
                >
                  ×
                </button>
              )}
            </div>
            {/* Search Bar */}
            <div style={{ position: 'relative' }}>
              <input
                type="text"
                placeholder="Search conversations..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: '100%',
                  padding: isMobile ? '8px 14px' : '10px 16px',
                  borderRadius: '20px',
                  border: 'none',
                  backgroundColor: 'rgba(255,255,255,0.2)',
                  color: 'white',
                  fontSize: '14px',
                  outline: 'none'
                }}
              />
              <div style={{
                position: 'absolute',
                right: '12px',
                top: '50%',
                transform: 'translateY(-50%)',
                opacity: '0.7'
              }}>
                🔍
              </div>
            </div>
          </div>
          {/* Contacts List */}
          <div style={{
            flex: 1,
            overflow: 'auto'
          }}>
            <div style={{
              padding: '16px 0',
              borderBottom: '1px solid #f0f0f0'
            }}>
              <div style={{
                padding: isMobile ? '0 16px' : '0 20px',
                fontSize: '12px',
                fontWeight: '600',
                color: '#666',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                marginBottom: '8px'
              }}>

              </div>
              {filteredContacts.map((contact) => (
                <div
                  key={contact.id}
                  onClick={() => handleContactSelect(contact.id)}
                  style={{
                    padding: isMobile ? '12px 16px' : '12px 20px',
                    cursor: 'pointer',
                    backgroundColor: selectedChat === contact.id ? '#f0f7ff' : 'transparent',
                    borderLeft: selectedChat === contact.id ? '3px solid #1976d2' : '3px solid transparent',
                    display: 'flex',
                    alignItems: 'center',
                    gap: isMobile ? '10px' : '12px',
                    transition: 'all 0.2s ease',
                    minHeight: isMobile ? '60px' : 'auto'
                  }}
                  onMouseEnter={(e) => {
                    if (selectedChat !== contact.id) {
                      e.target.style.backgroundColor = '#f8f9fa';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (selectedChat !== contact.id) {
                      e.target.style.backgroundColor = 'transparent';
                    }
                  }}
                >
                  <div style={{ position: 'relative' }}>
                    <div style={{
                      width: isMobile ? '44px' : '48px',
                      height: isMobile ? '44px' : '48px',
                      borderRadius: '50%',
                      backgroundColor: contact.color,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: isMobile ? '14px' : '16px',
                      fontWeight: 'bold',
                      color: 'white'
                    }}>
                      {contact.avatar}
                    </div>
                    {contact.isOnline && (
                      <div style={{
                        position: 'absolute',
                        bottom: '2px',
                        right: '2px',
                        width: '12px',
                        height: '12px',
                        borderRadius: '50%',
                        backgroundColor: '#4caf50',
                        border: '2px solid white'
                      }}></div>
                    )}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: '4px'
                    }}>
                      <div style={{
                        fontSize: isMobile ? '15px' : '16px',
                        fontWeight: '500',
                        color: '#333',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                      }}>
                        {contact.name}
                      </div>
                      <div style={{
                        fontSize: '12px',
                        color: '#666',
                        flexShrink: 0
                      }}>
                        {formatTime(contact.timestamp)}
                      </div>
                    </div>
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}>
                      <div style={{
                        fontSize: isMobile ? '13px' : '14px',
                        color: '#666',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        flex: 1
                      }}>
                        {contact.lastMessage}
                      </div>
                      {contact.unreadCount > 0 && (
                        <div style={{
                          backgroundColor: '#dc004e',
                          color: 'white',
                          borderRadius: '50%',
                          width: '20px',
                          height: '20px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '12px',
                          fontWeight: 'bold',
                          marginLeft: '8px'
                        }}>
                          {contact.unreadCount}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* Main Chat Area */}
        <div style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          width: isMobile ? '100%' : 'calc(100% - 360px)'
        }}>
          {/* Chat Header */}
          <div style={{
            backgroundColor: '#1976d2',
            color: 'white',
            padding: isMobile ? '12px 16px' : '16px 20px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}>
            {isMobile && (
              <button
                onClick={() => setShowSidebar(true)}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'white',
                  fontSize: '18px',
                  cursor: 'pointer',
                  padding: '4px',
                  marginRight: '4px'
                }}
              >
                ☰
              </button>
            )}
            <div style={{
              width: isMobile ? '36px' : '40px',
              height: isMobile ? '36px' : '40px',
              borderRadius: '50%',
              backgroundColor: contacts[selectedChat].color,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: isMobile ? '12px' : '14px',
              fontWeight: 'bold'
            }}>
              {contacts[selectedChat].avatar}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: isMobile ? '16px' : '18px', fontWeight: '600' }}>
                {contacts[selectedChat].name}
              </div>
              <div style={{
                fontSize: '12px',
                opacity: '0.8',
                display: 'flex',
                alignItems: 'center',
                gap: '4px'
              }}>
                <span style={{
                  width: '8px',
                  height: '8px',
                  borderRadius: '50%',
                  backgroundColor: contacts[selectedChat].isOnline ? '#4caf50' : '#666',
                  display: 'inline-block'
                }}></span>
                {contacts[selectedChat].isOnline ? 'Online' : 'Offline'}
              </div>
            </div>
          </div>
          {/* Messages Area */}
          <div style={{
            flex: 1,
            overflow: 'auto',
            padding: isMobile ? '12px' : '16px',
            backgroundImage: 'linear-gradient(45deg, #f5f5f5 25%, transparent 25%), linear-gradient(-45deg, #f5f5f5 25%, transparent 25%)',
            backgroundSize: '20px 20px'
          }}>
            {messages.map((message, idx) => (
  <div
    key={message.id}
    style={{
      display: 'flex',
      flexDirection: message.isMe ? 'row-reverse' : 'row',
      alignItems: 'flex-end',
      marginBottom: isMobile ? '12px' : '16px',
      gap: isMobile ? '6px' : '8px',
      position: 'relative'
    }}
    onContextMenu={e => {
      e.preventDefault();
      setReplyTo(message);
    }}
  >
    {/* Avatar */}
    <div style={{
      width: isMobile ? '28px' : '32px',
      height: isMobile ? '28px' : '32px',
      borderRadius: '50%',
      backgroundColor: message.color,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: isMobile ? '10px' : '12px',
      fontWeight: 'bold',
      color: 'white',
      flexShrink: 0
    }}>
      {message.avatar}
    </div>
    {/* Message bubble and menu */}
    <div style={{
      maxWidth: isMobile ? '80%' : '70%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: message.isMe ? 'flex-end' : 'flex-start',
      position: 'relative'
    }}>
      {/* Reply preview above bubble */}
      {message.replyTo && (
        <div
          style={{
            background: '#f0f7ff',
            borderLeft: '3px solid #1976d2',
            padding: '4px 8px',
            marginBottom: '4px',
            borderRadius: '6px',
            fontSize: '12px',
            color: '#1976d2',
            cursor: 'pointer'
          }}
          onClick={e => {
            e.stopPropagation();
            setReplyTo(messages.find(m => m.id === message.replyTo.id));
          }}
        >
          <span style={{ fontWeight: 'bold' }}>Reply:</span>{" "}
          {message.replyTo.text || message.replyTo.label || message.replyTo.fileName}
        </div>
      )}
      {/* Message bubble */}
      <div style={{
        backgroundColor: message.isMe ? '#1976d2' : '#ffffff',
        color: message.isMe ? 'white' : '#333',
        padding: isMobile ? '10px 14px' : '12px 16px',
        borderRadius: '18px',
        borderTopLeftRadius: message.isMe ? '18px' : '4px',
        borderTopRightRadius: message.isMe ? '4px' : '18px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        wordBreak: 'break-word',
        fontSize: isMobile ? '15px' : '14px',
        lineHeight: '1.4',
        position: 'relative'
      }}>
        {message.icon && (
          <span style={{ marginRight: 6 }}>{message.icon}</span>
        )}
        {message.text || message.label || message.fileName}
      </div>
      {/* View text for file/template messages */}
      <div  style={{
          display: 'flex',
          gap: '10px',
          }}>
      {(message.type === 'file' || message.type === 'template') && (
        <div
          style={{
            marginTop: '2px',
            color: '#673ab7',
            fontSize: '13px',
            cursor: 'pointer',
            alignSelf: message.isMe ? 'flex-end' : 'flex-start',
            userSelect: 'none',
            textDecoration: 'underline'
          }}
          onClick={() => {
            // For file: open/download; for template: show modal
            if (message.type === 'file' && message.fileObject) {
              const url = URL.createObjectURL(message.fileObject);
              window.open(url, '_blank');
            } else if (message.type === 'template') {
              setSelectedTemplateMessage(message);
            }
          }}
        >
          View
        </div>
      )}
      {/* Reply text link below bubble */}
      <div
        style={{
          marginTop: '2px',
          color: '#1976d2',
          fontSize: '13px',
          cursor: 'pointer',
          alignSelf: message.isMe ? 'flex-end' : 'flex-start',
          userSelect: 'none'
        }}
        onClick={() => setReplyTo(message)}
      >
        Reply
      </div>
      </div>
      {/* Timestamp */}
      <div style={{
        fontSize: '11px',
        color: '#666',
        marginTop: '4px',
        marginLeft: message.isMe ? '0' : '8px',
        marginRight: message.isMe ? '8px' : '0'
      }}>
        {formatTime(message.timestamp)}
      </div>
    </div>
  </div>
))}


            {selectedTemplateMessage && (
              <div style={{
                position: 'fixed',
                top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2001
              }}>
                <div style={{
                  backgroundColor: 'white',
                  padding: '24px',
                  borderRadius: '8px',
                  width: '90%',
                  maxWidth: '450px',
                  boxShadow: '0 2px 12px rgba(0,0,0,0.2)',
                  position: 'relative'
                }}>
                  <button
                    onClick={() => setSelectedTemplateMessage(null)}
                    style={{
                      position: 'absolute',
                      top: '8px',
                      right: '12px',
                      background: 'none',
                      border: 'none',
                      fontSize: '20px',
                      cursor: 'pointer',
                      color: '#888'
                    }}
                  >
                    ×
                  </button>
                  <h2>Template Text</h2>
                  <div style={{ marginBottom: '16px', fontSize: '16px', color: '#4527a0' }}>
                    {selectedTemplateMessage.label}
                  </div>
                  {/* You can add more details here if needed */}
                </div>
              </div>
            )}
            {isTyping && (
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: isMobile ? '6px' : '8px',
                marginBottom: isMobile ? '12px' : '16px'
              }}>
                <div style={{
                  width: isMobile ? '28px' : '32px',
                  height: isMobile ? '28px' : '32px',
                  borderRadius: '50%',
                  backgroundColor: contacts[selectedChat].color,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: isMobile ? '10px' : '12px',
                  fontWeight: 'bold',
                  color: 'white'
                }}>
                  {contacts[selectedChat].avatar}
                </div>
                <div style={{
                  backgroundColor: '#e0e0e0',
                  padding: isMobile ? '6px 12px' : '8px 16px',
                  borderRadius: '12px',
                  fontSize: '12px',
                  color: '#666',
                  animation: 'pulse 1.5s infinite'
                }}>
                  Typing...
                </div>
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>
          {/* Message Input */}
          <div style={{
            backgroundColor: 'white',
            padding: isMobile ? '12px' : '16px',
            boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
            borderTop: '1px solid #e0e0e0'
          }}>
            {replyTo && (
              <div style={{
                background: '#f0f7ff',
                borderLeft: '4px solid #1976d2',
                padding: '8px 12px',
                marginBottom: '8px',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}>
                <div>
                  <strong>Replying to:</strong> {replyTo.text || replyTo.label || replyTo.fileName}
                </div>
                <button
                  onClick={() => setReplyTo(null)}
                  style={{
                    background: 'none',
                    border: 'none',
                    fontSize: '18px',
                    cursor: 'pointer',
                    color: '#888',
                    marginLeft: '12px'
                  }}
                >×</button>
              </div>
            )}
            <div style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: isMobile ? '6px' : '8px'
            }}>
              <div style={{ position: 'relative' }}>
                <label htmlFor="fileInput" style={{
                  display: 'inline-block',
                  width: isMobile ? '40px' : '48px',
                  height: isMobile ? '40px' : '48px',
                  cursor: 'pointer',
                  borderRadius: '50%',
                  overflow: 'hidden'
                }}>
                  <div
                    style={{
                      width: '100%',
                      height: '100%',
                      backgroundColor: '#f5f5f5',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: isMobile ? '16px' : '18px'
                    }}
                  >
                    📎
                  </div>
                </label>
                <input
                  id="fileInput"
                  type="file"
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.ppt,.pptx,.jpg,.jpeg,.png"
                  style={{
                    display: 'none'
                  }}
                  onChange={handleFileChange}
                />
              </div>
              {/* Template Button */}
              <button
                type="button"
                onClick={() => setShowTemplateModal(true)}
                style={{
                  padding: isMobile ? '8px 10px' : '11px 14px',
                  fontSize: isMobile ? '12px' : '14px',
                  backgroundColor: '#eee',
                  border: '1px solid #ccc',
                  borderRadius: '20px',
                  cursor: 'pointer',
                  position: 'relative'
                }}
              >
                <File size={20} color="#555" />
              </button>
              <div style={{
                flex: 1,
                position: 'relative'
              }}>
                <textarea
                  value={newMessage}
                  onChange={(e) => setNewMessage(e.target.value)}
                  onKeyPress={handleKeyPress}
                  placeholder="Type a message..."
                  style={{
                    width: '100%',
                    minHeight: isMobile ? '40px' : '44px',
                    maxHeight: isMobile ? '100px' : '120px',
                    padding: isMobile ? '10px 45px 10px 14px' : '12px 50px 12px 16px',
                    borderRadius: '22px',
                    border: '1px solid #e0e0e0',
                    backgroundColor: '#f8f9fa',
                    fontSize: isMobile ? '16px' : '14px',
                    resize: 'none',
                    outline: 'none',
                    fontFamily: 'inherit',
                    lineHeight: '1.4'
                  }}
                  rows="1"
                />
              </div>
              <button
                onClick={handleSendMessage}
                disabled={!newMessage.trim()}
                style={{
                  width: isMobile ? '44px' : '48px',
                  height: isMobile ? '44px' : '48px',
                  borderRadius: '50%',
                  backgroundColor: newMessage.trim() ? '#1976d2' : '#ccc',
                  border: 'none',
                  color: 'white',
                  cursor: newMessage.trim() ? 'pointer' : 'not-allowed',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: isMobile ? '18px' : '20px',
                  transition: 'all 0.2s ease',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                  minWidth: isMobile ? '44px' : '48px',
                  minHeight: isMobile ? '44px' : '48px'
                }}
              >
                ➤
              </button>
            </div>
          </div>
        </div>
        <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
        input:focus, textarea:focus {
          border-color: #1976d2 !important;
          box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2) !important;
        }
        input::placeholder {
          color: rgba(255, 255, 255, 0.7);
        }
        button:hover:not(:disabled) {
          opacity: 0.9;
          transform: scale(1.05);
        }
        button:active {
          transform: scale(0.95);
        }
        /* Mobile touch improvements */
        @media (max-width: 768px) {
          button {
            -webkit-tap-highlight-color: rgba(0,0,0,0.1);
            tap-highlight-color: rgba(0,0,0,0.1);
          }
          textarea {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
          }
        }
        ::-webkit-scrollbar {
          width: 6px;
        }
        ::-webkit-scrollbar-track {
          background: #f1f1f1;
        }
        ::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 3px;
        }
        ::-webkit-scrollbar-thumb:hover {
          background: #a8a8a8;
        }
        /* Mobile scrollbar */
        @media (max-width: 768px) {
          ::-webkit-scrollbar {
            width: 4px;
          }
        }
      `}</style>
      </div>
      {/* {showTemplateModal && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 2000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '24px',
            borderRadius: '8px',
            width: '90%',
            maxWidth: '400px',
            boxShadow: '0 2px 12px rgba(0,0,0,0.2)',
            position: 'relative'
          }}>
            <h2 style={{ marginTop: 0 }}>Select a Template</h2>
            {templates.map(tpl => (
              <div
                key={tpl.id}
                onClick={() => {
                  const injectedMessages = tpl.messages.map(m => ({
                    id: `tpl-${m.id}-${Date.now()}`,
                    type: 'template',
                    label: m.label,
                    icon: m.icon,
                    isMe: true,
                    avatar: 'ME',
                    color: '#673ab7',
                    timestamp: new Date()
                  }));
                  setMessages(prev => [...prev, ...injectedMessages]);
                  setShowTemplateModal(false);
                }}
                style={{
                  padding: '12px',
                  marginBottom: '8px',
                  backgroundColor: '#f0f0f0',
                  borderRadius: '6px',
                  cursor: 'pointer'
                }}
              >
                {tpl.name}
              </div>
            ))}
            <button
              onClick={() => setShowTemplateModal(false)}
              style={{
                position: 'absolute',
                top: '8px',
                right: '12px',
                background: 'none',
                border: 'none',
                fontSize: '20px',
                cursor: 'pointer',
                color: '#888'
              }}
            >
              ×
            </button>
          </div>
        </div>
      )} */}
      {showTemplateModal && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 2000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '24px',
            borderRadius: '8px',
            width: '90%',
            maxWidth: '600px',
            boxShadow: '0 2px 12px rgba(0,0,0,0.2)',
            position: 'relative'
          }}>
            <h2 style={{ marginTop: 0 }}>Select a Template</h2>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
              gap: '16px',
              marginTop: '20px'
            }}>
              {templates.map(tpl => {
                const templateIcon = tpl.messages[0]?.icon || '📄';

                return (
                  <div
                    key={tpl.id}
                    style={{
                      padding: '16px',
                      backgroundColor: '#f5f5f5',
                      borderRadius: '12px',
                      textAlign: 'center',
                      fontWeight: 'bold',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      height: '300px'
                    }}
                  >
                    <div style={{ fontSize: '80px', marginBottom: '8px' }}>{templateIcon}</div>
                    <div style={{ fontSize: '16px', marginBottom: '8px' }}>{tpl.name}</div>

                    <input
                      type="date"
                      value={selectedDates[tpl.id] || ''}
                      onChange={(e) =>
                        setSelectedDates(prev => ({ ...prev, [tpl.id]: e.target.value }))
                      }
                      style={{
                        padding: '6px 12px',
                        borderRadius: '6px',
                        border: '1px solid #ccc',
                        marginBottom: '10px',
                        width: '100%'
                      }}
                    />

                    <button
                      onClick={() => {
                        const selectedDate = selectedDates[tpl.id];
                        const injectedMessages = tpl.messages.map(m => ({
                          id: `tpl-${m.id}-${Date.now()}`,
                          type: 'template',
                          label: `${m.label} (${selectedDate || 'No date selected'})`,
                          icon: m.icon,
                          isMe: true,
                          avatar: 'ME',
                          color: '#673ab7',
                          timestamp: new Date()
                        }));
                        setMessages(prev => [...prev, ...injectedMessages]);
                        setShowTemplateModal(false);
                      }}
                      style={{
                        backgroundColor: '#673ab7',
                        color: '#fff',
                        border: 'none',
                        padding: '8px 16px',
                        borderRadius: '6px',
                        cursor: 'pointer'
                      }}
                    >
                      Submit
                    </button>
                  </div>
                );
              })}
            </div>

            <button
              onClick={() => setShowTemplateModal(false)}
              style={{
                position: 'absolute',
                top: '8px',
                right: '12px',
                background: 'none',
                border: 'none',
                fontSize: '20px',
                cursor: 'pointer',
                color: '#888'
              }}
            >
              ×
            </button>
          </div>
        </div>
      )}




      {selectedTemplateMessage && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 2001
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '24px',
            borderRadius: '8px',
            width: '90%',
            maxWidth: '450px',
            boxShadow: '0 2px 12px rgba(0,0,0,0.2)',
            position: 'relative'
          }}>
            <button
              onClick={() => setSelectedTemplateMessage(null)}
              style={{
                position: 'absolute',
                top: '8px',
                right: '12px',
                background: 'none',
                border: 'none',
                fontSize: '20px',
                cursor: 'pointer',
                color: '#888'
              }}
            >
              ×
            </button>
            <h2>{selectedTemplateMessage.label} Form</h2>
            <form onSubmit={(e) => {
              e.preventDefault();
              alert(`Form for "${selectedTemplateMessage.label}" submitted!`);
              setSelectedTemplateMessage(null);
            }}>
              <div style={{ marginBottom: '12px' }}>
                <label>Field 1</label>
                <input type="text" required style={{ width: '100%', padding: '8px' }} />
              </div>
              <div style={{ marginBottom: '12px' }}>
                <label>Field 2</label>
                <textarea required style={{ width: '100%', padding: '8px' }} />
              </div>
              <button type="submit" style={{
                padding: '10px 16px',
                backgroundColor: '#1976d2',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer'
              }}>
                Submit
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};
export default ChatApp;